import { createSlice } from "@reduxjs/toolkit";

const loadCartFromStorage = () => {
    try {
        return JSON.parse(localStorage.getItem("cart")) || [];
    } catch {
        return [];
    }
};

const saveCartToStorage = (items) => {
    localStorage.setItem("cart", JSON.stringify(items));
};

const initialValue = {
    items: loadCartFromStorage(),
};

const productInCartSlice = createSlice({
    name: "productInCart",
    initialState: initialValue,

    reducers: {
        SET_LOGGED_PRODUCTINCART: (state, action) => {
            state.items = action.payload || [];
            saveCartToStorage(state.items);
        },

        ADD_ITEM: (state, action) => {
            const incoming = action.payload;
            const incomingOptionId = incoming.productOptionId ?? null;

            if (incoming.id != null) {
                const idx = state.items.findIndex(i => i.id === incoming.id);
                if (idx !== -1) {
                    state.items[idx] = { ...state.items[idx], ...incoming };
                    saveCartToStorage(state.items);
                    return;
                }
            }

            const idx = state.items.findIndex(
                i =>
                    i.productId === incoming.productId &&
                    (i.productOptionId ?? null) === incomingOptionId
            );

            if (idx !== -1) {
                state.items[idx] = {
                    ...state.items[idx],
                    ...incoming,
                    productOption: incoming.productOption ?? state.items[idx].productOption,
                    product: incoming.product ?? state.items[idx].product,
                };
            } else {
                state.items.push(incoming);
            }

            saveCartToStorage(state.items);
        },

        REMOVE_ITEM: (state, action) => {
            const itemId = action.payload;
            state.items = state.items.filter(i => i.id !== itemId);
            saveCartToStorage(state.items);
        },

        CLEAR_CART: (state) => {
            state.items = [];
            localStorage.removeItem("cart");
        },

        UPDATE_ITEM_AMOUNT: (state, action) => {
            const { id, amount } = action.payload;
            const idx = state.items.findIndex(x => x.id === id);

            if (idx !== -1) {
                state.items[idx].amount = amount;
                saveCartToStorage(state.items);
            }
        },
    }
});

export const {
    SET_LOGGED_PRODUCTINCART,
    ADD_ITEM,
    REMOVE_ITEM,
    CLEAR_CART,
    UPDATE_ITEM_AMOUNT
} = productInCartSlice.actions;

export default productInCartSlice.reducer;